'use client';

import React from 'react';
import { classnames } from '@/utils/classnames/classnames';
import { OverlayProps } from '../overlay/types';

const Overlay = ({ onClick, zIndex, bg, className = '' }: OverlayProps) => {
  const overlayClassNames = classnames(
    className,
    zIndex ?? 'z-[305]',
    'fixed left-0 top-0 h-screen w-screen bg-gray-800/45',
  );
    return <div id='overlay' style={{ overflowY: 'auto' }} className={`fixed left-0 top-0 ${zIndex || 'z-[250]'} ${bg || 'bg-[#7f7f7f]/60'} h-screen w-screen overflow-y-auto`} onClick={onClick} />;

};

export default Overlay;
